import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Price.scss';

const PriceD = ({priceData, color = ''}) => {
	if (!priceData) {
		return null;
	}

	return (
	  <div className={`${styles.container} ${styles.sizeBodyText} ${color ? styles[color] : ''}`}>
		  <div className={styles.prices}>
			  <div className={styles.priceContainer}>
				  <div className={`${styles.price} ${styles.sizeBodyText}`}>
					  {priceData.price}
				  </div>
				  <div>
					  {priceData.text}
				  </div>
			  </div>
		  </div>
	  </div>
	);
}

PriceD.propTypes = {
	priceData: PropTypes.object.isRequired,
	color: PropTypes.string
};

export default PriceD;
